import { render } from "./CuentasPorPagar.vue?vue&type=template&id=b256de90&scoped=true"
import script from "./CuentasPorPagar.vue?vue&type=script&lang=js"
export * from "./CuentasPorPagar.vue?vue&type=script&lang=js"

import "./CuentasPorPagar.vue?vue&type=style&index=0&id=b256de90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b256de90"]])

export default __exports__